import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Empty.scss';
import EmptyImg from '../../assets/images/group/empty@2x.png';

class Empty extends Component {
  render () {
    return (
      <div className='empty'>
        <img src={EmptyImg} alt=""/>
        <div className='tip'>{this.props.tip}</div>
        {this.props.btnTitle && <div className='btn' onClick={this.props.btnClickFunc}>{this.props.btnTitle}</div>}
      </div>
    )
  }
}

Empty.propTypes = {
  tip: PropTypes.string,
  btnTitle: PropTypes.string,
  btnClickFunc: PropTypes.func
}

export default Empty;